import { createAsyncThunk } from '@reduxjs/toolkit';
import { batch } from 'react-redux';

import { authSet } from '../../utils/request';
import { METHOD_PATCH } from '../../constants/api';
import getRoles from './getRoles';
import getRoleDetails from './getRoleDetails';

const patchRoles = createAsyncThunk('roles/postRoles',
  async ({ id, ...props } = {}, { dispatch, rejectWithValue }) => {
    try {
      const { id: patchedId } = await authSet(METHOD_PATCH, `/roles/${id}`, props);
      batch(() => {
        dispatch(getRoles());
        dispatch(getRoleDetails(patchedId));
      });
      return patchedId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchRoles;
